export enum CapacityModeEnum {
  DEFAULT = 'DEFAULT',
  HOUSE_SEARCH = 'HOUSE_SEARCH',
}
